import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { Button } from "../../../components/Buttons";

export const Queue = () => {
    document.title = "Gözləmə";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Kassa", value: "/cash" },
        { name: "Gözləmə", value: "/cash/queue", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Gözləmə</h2>
                    <p>
                        Kassa qarşısında yaranan növbələri aradan qaldırmaq və müştəri məmnuniyyətini artırmaq üçün nəzərdə tutulub
                        <ol>
                            <li>
                                Eyni anda bir neçə satışı icra etmək üçün <Button>+</Button> düyməsi ilə satış pəncərəsi açmaq lazımdır
                            </li>
                            <li>Hər bir pəncərəyə müxtəlif məhsulları əlavə etmək, endirim təyin etmək və satış etmək olar</li>
                        </ol>
                    </p>
                    <img src="/images/cash/queue.gif" alt="Gözləmə" />
                </article>
            </div>
        </div>
    );
};
